import React from "react";
import CompositeColorPicker from "../../../Composites/CompositeColorPicker/CompositeColorPicker";
import { ColorTrigger, Flex, Text } from "@theorgchartdev/storybook";
import { appstr } from "@coreapp/utils/appstr";

const HighlightSection = props => {
  const handleChange = selectedColor => {
    const rule = props.rule.Clone();
    rule.SetRuleHighlightColor(selectedColor);
    props.setRule(rule);
  };

  return (
    <Flex direction={"column"} gap={"12px"}>
      <Text size={"small"}>
        {appstr("Overlay a region of color over boxes that match the criteria")}
      </Text>
      <div style={{ padding: "8px", display: "flex" }}>
        <CompositeColorPicker
          trigger={<ColorTrigger iconName="pen" size={"medium"} />}
          onChange={handleChange}
          currentColor={props.rule.GetRuleHighlightColor()}
        />
      </div>
    </Flex>
  );
};

export default HighlightSection;
